import React from "react";
import HeroCarousel from "./Hero";
import Services from "./Services";
import AboutCompany from "./AboutCompany";

const Home = () => {
  return (
    <div className="overflow-hidden">
      <HeroCarousel />
      <AboutCompany />
      <Services />
    </div>
  );
};

export default Home;
